import React from "react";

import { VideoRecordingDurationGraphData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideoRecordingDuration/VideoRecordingDurationGraphData";
import { VideoRecordingDurationRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/VideoRecordingDuration/VideoRecordingDurationRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface VideoRecordingDurationProps {}

export const VideoRecordingDuration: React.FC<VideoRecordingDurationProps> = () => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>
      {selectedDialogTab === "Raw Data" ? <VideoRecordingDurationRawData /> : <VideoRecordingDurationGraphData />}
    </div>
  );
};
